import React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { usePageTitle } from '../hooks/usePageTitle';
import { Button, Card, CardBody, LayoutContainer, MessageBlock } from '../components/ui';
import { isRetryableTokenValidationError } from '../utils/tokenValidationError';
import '../styles/infrastructureScreens.css';

const TOKEN_UNAVAILABLE = {
  title: 'Acceso no disponible',
  message: 'Este enlace ya no es válido.\nPedile al vendedor que genere uno nuevo.',
};

const ERROR_COPY = {
  token_expired: TOKEN_UNAVAILABLE,
  invalid_token: TOKEN_UNAVAILABLE,
  flow_cancelled: TOKEN_UNAVAILABLE,
  flow_completed: {
    title: 'Trámite completado',
    message: 'Este trámite ya fue finalizado.\nNo es necesario volver a ingresar.',
  },
  request_timeout: {
    title: 'No se pudo verificar el acceso',
    message: 'El servidor tardó demasiado en responder. Por favor intenta de nuevo.',
  },
  network_error: {
    title: 'No se pudo verificar el acceso',
    message: 'No se pudo conectar con el servidor. Verificá tu conexión.',
  },
};

const MobileErrorPage = ({ error }) => {
  const { type } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const errorType = error || type;
  const retryPath = location.state?.retryPath;
  const canRetry = isRetryableTokenValidationError(errorType) && Boolean(retryPath);

  usePageTitle('Portal Autogestión');

  const { title, message } = ERROR_COPY[errorType] || TOKEN_UNAVAILABLE;

  return (
    <div className="rg-infra-screen rg-mobile-error">
      <LayoutContainer size="md" className="rg-mobile-error__container">
        <Card className="rg-mobile-error__card rg-elevation-2">
          <CardBody className="rg-mobile-error__card-body">
            <div className="rg-mobile-error__icon-wrap" aria-hidden="true">
              <FontAwesomeIcon icon={faExclamationTriangle} className="rg-mobile-error__icon" />
            </div>

            <MessageBlock
              tone="warning"
              title={title}
              className="rg-mobile-error__message"
              actions={canRetry ? (
                <Button
                  variant="primary"
                  onClick={() => navigate(retryPath, { replace: true })}
                >
                  Reintentar
                </Button>
              ) : undefined}
            >
              {message}
            </MessageBlock>
          </CardBody>
        </Card>
      </LayoutContainer>
    </div>
  );
};

export default MobileErrorPage; 